import toggleCancelledDialog from "./toggleCancelledDialog";
import addTripDialog from "./AddTripDialog";
import EditTripDialog from "./EditTripDialog";
import EditCrewDialog from "./EditCrewDialog";
import EditPaxDialog from "./EditPaxDialog";
import EditServicesDialog from "./EditServicesDialog";
import EditCateringDialog from "./EditCateringDialog";
import EditScheduledServicesDialog from "./EditScheduledServicesDialog";


const TripListDialogs = (SystemData, apiSitePrefix, extraKeys, handleAdd, handleUpdate, handledDelete, formatChars, classes, ownerDepartment = "COMMERCIAL") => {
  const toggleCancelled = toggleCancelledDialog(SystemData, handleUpdate, extraKeys);
  const {Dialog: AddTripDialog, open: openAddTrip, close: closeAddTrip} = addTripDialog(SystemData, apiSitePrefix, extraKeys, handleAdd, formatChars, classes, ownerDepartment);
  //const {Dialog: EditTripDialog, open: openEditTrip, close: closeEditTrip} = editTripDialog(SystemData, apiSitePrefix, extraKeys, handleUpdate, formatChars, classes);

  return {
    toggleCancelled,
    AddTripDialog, openAddTrip, closeAddTrip,
    //EditTripDialog, openEditTrip, closeEditTrip,
  }
}

export {
  EditCrewDialog,
  EditPaxDialog,
  EditServicesDialog,
  EditCateringDialog,
  EditTripDialog,
  EditScheduledServicesDialog,
}

export default TripListDialogs;
